module.exports = "images/apple-icon-60x60.91067681af6d2dd580af9900c45734cf.png";